import { Customer } from 'types/Customer';
import { SavePet } from 'types/Pet';

export interface IntakeFormState {
    loading: boolean;
    step: IntakeFormStep;
    customer: Customer;
    pets: Array<SavePet>;
}

export enum IntakeFormStep {
    Initial,
    CustomerForm,
    AddPetForm,
    PetList,
    CardOnFile,
    Success
}
